import { Component, OnInit } from '@angular/core';
import {HttpserviceService} from '../common/services/httpservice.service';
import {retry} from 'rxjs/operators';
import { SessionsService } from '../common/services/sessions.service';
import { Router,ActivatedRoute  } from '@angular/router';
import {ConstantsService} from '../common/services/constants.service';
declare var show_okshan_alert3: Function;

@Component({
  selector: 'app-live-okshan-link',
  templateUrl: './live-okshan-link.component.html',
  styleUrls: ['./live-okshan-link.component.css']
})
export class LiveOkshanLinkComponent implements OnInit {

  constructor(
  private httpserviceService:HttpserviceService,
  private sessionsService:SessionsService,
  private router:Router,
  private _constant: ConstantsService,
  private route:ActivatedRoute
  ) { }

 
  fileUrl;
  data;
  details:any={};
  linkIsValid:boolean=true;
  bidList:any=[];
 
  ngOnInit(): void {
  if(this.route.snapshot.queryParamMap.get('qzwxy')!=null)
  {
  this.data=atob(this.route.snapshot.queryParamMap.get('qzwxy'));  
  this.handleData(JSON.parse(this.data));
  }
  else
  {
    this.linkIsValid=false;
  }
  this.fileUrl=this._constant.uploadFileUrl;
  }

  handleData(data)
  {
    if(data.id)
    {
          const interval = setInterval(() => {
          if (this.sessionsService.getSession('auth_user') != null ) {
          this.getOkshanLiveLinkDetail(data)
        clearInterval(interval);      
          }      
        }, 100);        
    }
    else
    {
      this.linkIsValid=false;
    }
  }

  /** getOkshanLiveLinkDetail function used to get okshan live link detail */
  getOkshanLiveLinkDetail(data)
  {
     let body={car_id:data.id}
     let result =this.httpserviceService.getOkshanLiveLinkDetailRequest(body).
     pipe(retry(0)).
     subscribe((data)=>this.getOkshanLiveLinkDetailResponse(data), 
     err => {
       show_okshan_alert3("Something went wrong !");
       console.log('Something went wrong ', err);       
    })       
  //}
  }

  

  /** saveJoinOkshanDetailResponse method used to handle response */
  getOkshanLiveLinkDetailResponse(response)
  {
    console.log('saveJoinOkshanDetailResponse '+ response.status);
    if(response.status==="success")  
     {
       if(response.details)
       {
       this.details=response.details[0];
       if(this.details.top_bids)
       {
         this.bidList=this.details.top_bids;
       }
       this.linkIsValid=true;  
       }
     }
     else
     {
     this.linkIsValid=false;  
     show_okshan_alert3(response.reason);     
     } 
  }

}
